/* AdminOverview — Landing page for /admin */
import css from '../AdminPage.module.css';
import { SECTIONS } from '../AdminPage';
import { Link } from 'react-router-dom';
import { usePermissions } from '../../../hooks/usePermissions';

export default function AdminOverview() {
  const { filterSections, isLoading } = usePermissions();
  const allLinks = SECTIONS.filter((s) => s.id !== 'overview');
  const links = isLoading ? allLinks : filterSections(allLinks);

  return (
    <>
      <div className={css.sectionHeader}>
        <div>
          <h1 className={css.sectionTitle}>Administration</h1>
          <p className={css.sectionSubtitle}>
            Manage users, pipelines, data fields, templates, and system configuration.
          </p>
        </div>
      </div>

      <div className={css.statsGrid}>
        {links.map((s) => (
          <Link key={s.id} to={s.path} style={{ textDecoration: 'none' }}>
            <div className={css.statCard} style={{ cursor: 'pointer' }}>
              <span style={{ fontSize: '1.5rem' }}>{s.icon}</span>
              <span className={css.statLabel}>{s.label}</span>
            </div>
          </Link>
        ))}
      </div>
    </>
  );
}
